import { i18n } from '@/commons/utils';
import { updateSkuDisplay } from './size-selector';
import { getIdSku } from './pdp-utils';

export const init = () => {
  const cncStoreLabel = cube.$('.buying-zone__tab-label--store');

  cncStoreLabel.addEventListener('click', e => {
    const visibleSelector = cube.$('#conversion-zone .sizes__wrapper--visible');
    if (visibleSelector && !visibleSelector.$('.sizes__size--selected') && !visibleSelector.dataset.usize) {
      cube.alert.error(i18n('pdm.pleaseSelectSize'));
      e.preventDefault();
    }
  });

  // Update redirection url if different model is already selected on load
  if (window.location.search.length && cube.urlParams.mc) {
    const redirectionUrl = `${cube.$('.js-redirect-after-login').dataset.urlFlat}?mc=${cube.urlParams.mc}`;
    cube.$('.js-redirect-after-login').dataset.urlModelSize = redirectionUrl;
  }

  // Set size & display store tab if user comes from a login redirection
  const loginSkuStorage = cube.storage.getItem('skuBeforeLogin');
  if (loginSkuStorage) {
    if (cube.$(`#conversion-zone .sizes__size[data-id="${loginSkuStorage}"]`)) {
      updateSkuDisplay(loginSkuStorage, cube.$id('conversion-zone'));
      const cncStore = cube.$id('cnc-store');
      cncStore.disabled = false;
      cncStore.checked = true;
    }

    cube.storage.remove('skuBeforeLogin');
  }

  cube.$('.buying-zone__tab-content--store').addEventListener('click', e => {
    const isNotLogguedMessageChild = e.target.closest('.buying-zone__not-loggued-message');

    if (e.target.tagName === 'A' && isNotLogguedMessageChild) {
      e.preventDefault();
      cube.storage.setItem('skuBeforeLogin', getIdSku());
      document.location.href = e.target.href;
    }
  });
};

export const updateTab = sku => {
  const storeTab = cube.$('.buying-zone__tab-content--store');
  storeTab.textContent = '';

  const userHasFavoriteStore = cube.$('.js-favorite-store');
  const sellableOnline = cube.$('#sellableOnline') && cube.$('#sellableOnline').value === 'true';

  let cncTemplate = '';

  if (!userHasFavoriteStore) {
    // If user doesn't have a favorite store, only update from warn message to store selection cta
    cncTemplate = `
      <button class="cta-v2 cta-v2--alt js-open-store-selector" data-icon=">">${i18n('pdm.instore.cta.checkstorestock')}</button>
    `;
  } else {
    // Else, update every infos
    const { name: nameOfStore, url: urlOfStore } = cube.$('.js-favorite-store').dataset;
    const userIsLoggued = cube.$('.js-user-status').dataset.isLoggued === 'true';

    // There are 3 updatable parts in the cnc tab :
    let stockStatus = '';
    let storeStockClass = 'buying-zone__store-stock-message';
    let cartButtons = '';
    let changeStoreInvite = '';

    const scriptHolder = cube.$('#pdm_productdetailsmaincartridge');
    const storeInfos = JSON.parse(scriptHolder.dataset.storeinfo);
    const securedStockLevel = storeInfos && storeInfos.securedStockLevel ? storeInfos.securedStockLevel : null;
    const phoneNumber =
      storeInfos && storeInfos.phoneNumber
        ? `<a href="tel:${storeInfos.phoneNumber}" class="buying-zone__store-stock-message--phone-link">${storeInfos.phoneNumber}</a>`
        : null;

    // 1. The stock status
    if (sku.dataset.favstoreStock === '0') {
      stockStatus = i18n('pdm.cnc1h.stock.notinstock', nameOfStore);
      storeStockClass += ' buying-zone__store-stock-message--no-stock';
    } else if (sku.dataset.favstoreStock > '0') {
      // If stock <= security stock
      if (sku.dataset.favstoreStock <= securedStockLevel) {
        stockStatus = i18n('pdm.cnc1h.stock.quantity.equal.or.below.securitylevel', phoneNumber);
        storeStockClass += ' buying-zone__store-stock-message--phone';
      } else if (sku.dataset.favstoreStock > securedStockLevel) {
        // If stock > security stock
        // If there is only 1 article in stock (no security stock)
        if (sku.dataset.favstoreStock === '1') {
          stockStatus = i18n('pdm.cnc1h.stock.quantity.singular', nameOfStore);
          storeStockClass += ' buying-zone__store-stock-message--in-stock';
        } else {
          // If there are multiple articles in stock
          stockStatus = i18n('pdm.cnc1h.stock.quantity.plural', nameOfStore, sku.dataset.favstoreStock);
          storeStockClass += ' buying-zone__store-stock-message--in-stock';
        }
      }
    }

    // 2. The CTA zone
    if (parseInt(sku.dataset.favstoreStock, 10) > 0) {
      if (sku.dataset.favstoreCnc1h === 'true') {
        if (userIsLoggued) {
          cartButtons = `
            <div class="cart-buttons cart-buttons--store">
              <button class="cta-v2 dkti-store js-add-to-cart--cnc1h ${!sellableOnline ? 'disabled cta-v2--disabled' : ''}" data-store-id="${cube.$('.js-favorite-store').dataset.id}">${i18n('pdm.cnc1h.bookingcta')}</button>
            </div>
          `;
        } else {
          const redirectAfterLoginUrl = cube.$('.js-redirect-after-login').dataset.urlModelSize;
          cartButtons = `
            <div class="cart-buttons cart-buttons--store">
              <span class="buying-zone__not-loggued-message">
                ${i18n('pdm.cnc1h.loggininvite', redirectAfterLoginUrl)}
              </span>
            </div>
          `;
        }
      } else {
        cartButtons = `
          <div class="cart-buttons cart-buttons--store">
            <span class="buying-zone__unavail-cnc-message">
              ${i18n('pdm.cnc1h.contactinvite', urlOfStore)}
            </span>
          </div>
        `;
      }
    }

    // 3. The store changing invite link
    if (sku.dataset.favstoreCnc1h === 'true' && parseInt(sku.dataset.favstoreStock, 10) > 0) {
      if (userIsLoggued)
        changeStoreInvite = `<a href="#" class="buying-zone__select-store js-open-store-selector">${i18n(
          'pdm.cnc1h.storechangeinvite.cncenabled'
        )}</a>`;
      else changeStoreInvite = '';
    } else
      changeStoreInvite = `<a href="#" class="buying-zone__select-store js-open-store-selector">${i18n(
        'pdm.cnc1h.storechangeinvite.cncdisabled'
      )}</a>`;

    cncTemplate = `
      <span class="${storeStockClass}">${stockStatus}</span>
      ${cartButtons}
      ${changeStoreInvite}
    `;
  }

  storeTab.insertAdjacentHTML('afterbegin', cncTemplate);
};

export const resetTab = () => {
  const storeTab = cube.$('.buying-zone__tab-content--store');

  if (storeTab) {
    cube.$('.buying-zone').classList.remove('buying-zone--shows-online-stock');
    const storeTabInput = cube.$('.buying-zone__tab-input--store');
    const onlineTabInput = cube.$('.buying-zone__tab-input--online');

    storeTabInput.checked = false;
    storeTabInput.disabled = true;
    onlineTabInput.checked = true;

    storeTab.innerHTML = `<div class="buying-zone__size-selection-invite">
      ${i18n('pdm.cnc1h.sizeselectinvite')}
      </div>`;
  }
};



// WEBPACK FOOTER //
// ./src/catalog/product-details/click-n-collect-tabs.js